import {SHORTCUTS_RESET, SHORTCUTS_SET_GRUPO} from "./actionTypes";

export const setShortcuts = (idGrupo, shortcuts) => ({
    type: SHORTCUTS_SET_GRUPO,
    idGrupo: idGrupo,
    payload: shortcuts
});

export const resetShortcuts = () => ({type: SHORTCUTS_RESET});
